/**
 * Submits the contact form to the CRM API.
 * The CRM API verifies Turnstile, saves the lead, and queues both emails.
 * @param {Object} formData - Contact details and optional custom email fields
 * @returns {Promise<Object>} The API response
 */
export const submitContactForm = async (formData) => {
  try {
    const payload = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      ...(formData.phone ? { phone: formData.phone } : {}),
      ...(formData.source ? { source: formData.source } : {}),
      ...(formData.formName ? { formName: formData.formName } : {}),
      ...(formData.turnstileToken ? { turnstileToken: formData.turnstileToken } : {}),
      ...(formData.customerSubject ? { customerSubject: formData.customerSubject } : {}),
      ...(formData.customerBody ? { customerBody: formData.customerBody } : {}),
      ...(formData.notificationSubject ? { notificationSubject: formData.notificationSubject } : {}),
      ...(formData.notificationBody ? { notificationBody: formData.notificationBody } : {}),
    };

    const response = await fetch('/crm/contacts/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();

    let data;
    try {
      data = JSON.parse(responseText);
    } catch (e) {
      console.error('Failed to parse response:', e);
      return {
        status: 'error',
        message: 'Invalid response from server'
      };
    }

    if (data.status === 'SUCCESS') {
      return {
        status: 'success',
        message: 'Message sent successfully! We will get back to you shortly.'
      };
    }

    return {
      status: 'error',
      message: data.message || 'Something went wrong. Please try again later.'
    };
  } catch (error) {
    console.error('Error sending contact form:', error);
    return {
      status: 'error',
      message: 'Failed to send your message. Please try again later.'
    };
  }
};
